export default __webpack_public_path__ + "static/media/the-word.54c54b21.png";